import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import LazyImage from "../../shared/lazy-image";
import { Text } from "@cars24/turbo-web/lib/text";
import { NUMBER } from "../../../constants/app-constants";

const EliteWhyChoose = ({
    section
}) => {
    const {pageSection = {} } = section || {};
    const { title = "Why choose Cars24 Elite?", description = "",  sectionData = [], subTitle = ""} = pageSection || {};

    return (
        <div styleName={"styles.eliteWhyChooseWrapper"}>
            <div styleName={"styles.titleWrapper"}>
                <Text
                    align="center"
                    as="h2"
                    fontWeight="semibold"
                    size="650"
                    transform="none"
                    color={"#101010"}
                >
                    {title}
                </Text>
                {subTitle && <Text
                    align="center"
                    as="p"
                    fontWeight="regular"
                    size="400"
                    transform="none"
                    color="#4B5563"
                >
                    {subTitle}
                </Text>}
                {description && <Text
                    align="center"
                    as="p"
                    fontWeight="regular"
                    size="400"
                    transform="none"
                    color="#4B5563"
                >
                    {description}
                </Text>}
            </div>
            <div styleName={"styles.eliteWhyCard"}>
                {sectionData.map((item, index) => {
                    const top = `${NUMBER.EIGHTY + index * NUMBER.ZERO}px`;
                    return (
                        <div key={`elite-why-choose-us-${index}`} style={{ top }} styleName={"styles.cardWrapper"}>
                            <div styleName={"styles.howitImage"}>
                                <LazyImage src={item.image.url} alt={item.image.alternativeText} />
                            </div>
                            <div styleName={"styles.cardText"}>

                                <Text
                                    align="left"
                                    as="span"
                                    fontWeight="semibold"
                                    size="300"
                                    transform="none"
                                    color={"#9CA3AF"}
                                >
                                    <font/>0{index + 1}
                                </Text>

                                <div styleName={"styles.text"}>
                                    <Text
                                        align="left"
                                        as="p"
                                        fontWeight="medium"
                                        size="500"
                                        transform="none"
                                        color="#101010"
                                    >
                                        {item.subTitle}
                                    </Text>
                                    <Text
                                        align="left"
                                        as="p"
                                        fontWeight="regular"
                                        size="350"
                                        transform="none"
                                        color={"#4B5563"}
                                    >
                                        {item.description}
                                    </Text>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

EliteWhyChoose.propTypes = {
    section: PropTypes.object
};

export default EliteWhyChoose;
